import { PriceBenchMark } from '../../store/PriceBenchMark';
import { CallResult, callExternalApi } from '../callExternalApi';

export async function getPriceBenchmarks(
  accountIds?: string[],
  signal?: AbortSignal
): Promise<CallResult<PriceBenchMark[]>> {
  if (!accountIds?.length)
    return { data: null, error: { message: 'Must provide account ID to fetch price benchmarks' } };

  return await callExternalApi<PriceBenchMark[]>({
    url: `api/price_benchmark?account_ids=${accountIds.join(',')}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      AccountScope: accountIds.join(',')
    },
    signal
  });
}

export async function getPriceBenchmarkById(id: string, accountIds?: string[]): Promise<CallResult<PriceBenchMark>> {
  if (!accountIds?.length)
    return { data: null, error: { message: 'Must provide account ID to fetch price benchmark' } };

  return await callExternalApi<PriceBenchMark>({
    url: `api/price_benchmark/${id}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      AccountScope: accountIds.join(',')
    }
  });
}
